export default __webpack_public_path__ + "static/media/I0005.bb477a0d.png";